import { Type } from '@sinclair/typebox';
export const SearchBodySchema = Type.Object({
    query: Type.String({ minLength: 1, maxLength: 1000 }),
    topK: Type.Optional(Type.Integer({ minimum: 1, maximum: 20 })),
});
export const SearchResponseSchema = Type.Object({
    results: Type.Array(Type.Object({
        chunkId: Type.String({ format: 'uuid' }),
        documentId: Type.String({ format: 'uuid' }),
        filename: Type.String(),
        text: Type.String(),
        chunkIndex: Type.Integer(),
        similarity: Type.Number(),
    })),
});
//# sourceMappingURL=search.js.map